import { combineReducers } from 'redux';
import userReducer from './userReducer';
//import srcReducer from './srcReducer';

const reducer = combineReducers({
    user: userReducer,
    //src:srcReducer
});

export default reducer;